import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarMinus, faCalendarPlus, faDumbbell, faCalendar, faGauge, faSearch, faEye, faPencil, faTrashCan, faPlus, faArrowRight, faTable, faArrowUpRightFromSquare, faFilter, faRefresh, faCalendarCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';
import { DateTime } from "luxon";

import { PAGE_SIZE_OPTIONS } from "../../Constants/FieldOptions";


function UserListDesktop(props) {
    const { listData, setPageSize, pageSize, previousCursors, onPreviousClicked, onNextClicked } = props;
    return (
        <div class="b-table">
            <div class="table-wrapper has-mobile-cards">
                <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Clinic Code</th>
                            <th>Trial Status</th>
                            <th>Created</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {listData && listData.map(function(datum, i){
                            return <tr key={datum.id}>
                                <td data-label="Name">{datum.firstName}&nbsp;{datum.lastName}</td>
                                <td data-label="Email">{datum.email}</td>
                                <td data-label="Clinic Code">{datum.clinicCode}</td>
                                <td data-label="Trial Status">
                                    <span class={`${datum.trialStatus === "paid" ? "tag is-success is-light" : "tag is-danger is-light"}`}>
                                        {datum.trialStatus}
                                    </span>
                                </td>
                                <td data-label="Created">{DateTime.fromSeconds(datum.created).toLocaleString(DateTime.DATETIME_MED)}</td>
                                <td class="is-actions-cell">
                                    <div class="buttons is-right">
                                        <Link to={`/user/${datum.id}`} class="button is-small is-primary" type="button">
                                            <FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View
                                        </Link>
                                    </div>
                                </td>
                            </tr>;
                        })}
                    </tbody>
                </table>

                <div class="columns">
                    <div class="column is-half">
                        <span class="select">
                            <select class={`input has-text-grey-light`}
                                     name="pageSize"
                                 onChange={(e)=>setPageSize(parseInt(e.target.value))}>
                                {PAGE_SIZE_OPTIONS.map(function(option, i){
                                    return <option selected={pageSize === option.value} value={option.value}>{option.label}</option>;
                                })}
                            </select>
                        </span>

                    </div>
                    <div class="column is-half has-text-right">
                        {previousCursors.length > 0 &&
                            <button class="button" onClick={onPreviousClicked}>Previous</button>
                        }
                        {listData.hasNextPage && <>
                            <button class="button" onClick={onNextClicked}>Next</button>
                        </>}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default UserListDesktop;
